import { render, staticRenderFns } from "./AdminMenuNew.vue?vue&type=template&id=7648c05c&"
import script from "./AdminMenuNew.vue?vue&type=script&lang=js&"
export * from "./AdminMenuNew.vue?vue&type=script&lang=js&"
import style0 from "./AdminMenuNew.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./AdminMenuNew.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports